<template>
  <div>
    <div class="pb-4">
      <PageHeader :title="'مدیریت بسته ' + (typeof pageTitle === 'string' ? pageTitle : '')" :items="pageHeaderItems" />
    </div>

    <TabLink :items="links">
      <div v-if="!$route.path.includes('faculty') && !$route.path.includes('support') && model.status === 0">
        <b-button variant="primary" :class="{ disable: model.status !== 0 && model.status !== 2 }" class="ms-2" @click="sendRequest"> درخواست مجوز دوره</b-button>
      </div>

      <div v-else-if="!$route.path.includes('faculty') && !$route.path.includes('support') && $route.params.packageId" class="d-flex">
        <b-button
          variant="danger"
          :class="{ disable: model.status === 3 || (model.status === 4 && addedUsers) }"
          class="px-4"
          @click="
            $bvModal.show('reject')
            model.licenseStatus = 3
          "
          >رد</b-button
        >
        <b-button
          variant="primary"
          class="ms-2"
          :class="{ disable: model.status === 2 }"
          @click="
            $bvModal.show('edit')
            model.licenseStatus = 2
          "
          >نیاز به اصلاح</b-button
        >
        <b-button
          variant="success"
          class="px-5 ms-2"
          :class="{ disable: model.status === 4 }"
          @click="
            model.licenseStatus = 4
            changeStaus()
          "
          >تایید</b-button
        >
      </div>
      <b-button v-else variant="primary" :class="{ disable: model.status !== 0 && model.status !== 2 }" class="ms-2" @click="sendRequest">درخواست مجوز دوره</b-button>
    </TabLink>

    <router-view></router-view>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="reject" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title> رد درخواست</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت رد درخواست"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
          :required="true"
          :showError="submit && !model.description"
          errortext="وارد کردن علت رد درخواست الزامی است."
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('reject')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="edit" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>نیاز به اصلاح</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت نیاز به اصلاح"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
          :required="true"
          :showError="submit && !model.description"
          errortext="وارد کردن علت نیاز به اصلاح الزامی است."
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('edit')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import TextAreaInput from '../../../components/common/form/formModules/TextAreaInput.vue'
import TabLink from '../../../components/common/TabLink.vue'
import Toast from '../../../components/common/Toast.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import skillUpCourseProvider from '../../../services/skillUp/course'
import listDataProvider from '../../../services/list'
import skillUpFrequentlyAskedQuestionsProvider from '../../../services/skillUp/question'
// import moocPackageProvider from '../../../services/mooc/package'
export default {
  page: {
    title: 'مدیریت بسته',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-packages',
  components: {
    TabLink,
    PageHeader,
    TextAreaInput,
    Toast,
  },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت بسته', active: true },
      ],
      currentAvailableStatus: {},
      model: {
        productId: +this.$route.params.packageId,
        productType: 1,
        licenseStatus: 0,
        description: '',
      },
      error: false,
      message: '',
      addedHeadlines: false,
      addedQuestions: false,
      addedUsers: false,
      addedContent: false,
      pageTitle: '',
      submit: false,
    }
  },
  computed: {
    links() {
      if (this.$route.params.packageId !== undefined) {
        return [
          {
            title: 'ثبت بسته',
            link:
              this.$route.params.packageId && this.$route.path.includes('faculty')
                ? `/list/facultyskilluppackages/detail/${this.$route.params.packageId}`
                : this.$route.params.packageId && this.$route.path.includes('support')
                ? `/list/supportskilluppackages/detail/${this.$route.params.packageId}`
                : this.$route.params.packageId && !this.$route.path.includes('faculty')
                ? `/list/skilluppackages/detail/${this.$route.params.packageId}`
                : this.$route.path.includes('faculty')
                ? '/list/facultyskilluppackages/add'
                : this.$route.path.includes('support')
                ? '/list/supportskilluppackages/add'
                : '/list/skilluppackages/add',
            disable: this.isFaculty,
          },
          {
            title: 'محتوا دوره',
            link:
              this.$route.params.packageId && this.$route.path.includes('faculty')
                ? `/list/facultyskilluppackages/${this.$route.params.packageId}/skilluppackagecourses`
                : this.$route.params.packageId && this.$route.path.includes('support')
                ? `/list/supportskilluppackages/${this.$route.params.packageId}/skilluppackagecourses`
                : this.$route.params.packageId && !this.$route.path.includes('faculty')
                ? `/list/skilluppackages/${this.$route.params.packageId}/skilluppackagecourses`
                : this.$route.path.includes('facultyskilluppackages')
                ? '/list/facultyskilluppackages/skilluppackagescourses'
                : this.$route.path.includes('supportskilluppackages')
                ? '/list/supportskilluppackages/skilluppackagescourses'
                : `/list/skilluppackages/skilluppackagecourses`,
          },
          {
            title: 'پیش نیاز',
            link:
              this.$route.params.packageId && this.$route.path.includes('faculty')
                ? `/list/facultyskilluppackages/${this.$route.params.packageId}/prerequisites`
                : this.$route.params.packageId && this.$route.path.includes('support')
                ? `/list/supportskilluppackages/${this.$route.params.packageId}/prerequisites`
                : this.$route.params.packageId && !this.$route.path.includes('faculty')
                ? `/list/skilluppackages/${this.$route.params.packageId}/prerequisites`
                : this.$route.path.includes('faculty')
                ? '/list/facultyskilluppackages/prerequisites'
                : this.$route.path.includes('support')
                ? '/list/supportskilluppackages/prerequisites'
                : '/list/skilluppackages/prerequisites',
          },
          {
            title: 'سوالات متداول',
            link:
              this.$route.params.packageId && this.$route.path.includes('faculty')
                ? `/list/facultyskilluppackages/questions/${this.$route.params.packageId}`
                : this.$route.params.packageId && this.$route.path.includes('support')
                ? `/list/supportskilluppackages/questions/${this.$route.params.packageId}`
                : this.$route.params.packageId && !this.$route.path.includes('faculty')
                ? `/list/skilluppackages/questions/${this.$route.params.packageId}`
                : this.$route.path.includes('faculty')
                ? '/list/fcultyskilluppackages/questions'
                : this.$route.path.includes('support')
                ? '/list/supportskilluppackages/questions'
                : '/list/skilluppackages/questions',
          },
          {
            title: 'نظرات',
            link:
              this.$route.params.packageId && this.$route.path.includes('faculty')
                ? `/list/facultyskilluppackages/${this.$route.params.packageId}/packagecomments`
                : this.$route.params.packageId && this.$route.path.includes('support')
                ? `/list/supportskilluppackages/${this.$route.params.packageId}/packagecomments`
                : this.$route.params.packageId && !this.$route.path.includes('faculty')
                ? `/list/skilluppackages/${this.$route.params.packageId}/packagecomments`
                : this.$route.path.includes('facultyskilluppackages')
                ? '/list/facultyskilluppackages/packagecomments'
                : this.$route.path.includes('supportskilluppackages')
                ? '/list/supportskilluppackages/packagecomments'
                : `/list/skilluppackages/packagecomments`,
          },

          {
            title: 'اعضا',
            link:
              this.$route.params.packageId && this.$route.path.includes('faculty')
                ? `/list/facultyskilluppackages/${this.$route.params.packageId}/users/`
                : this.$route.params.packageId && this.$route.path.includes('support')
                ? `/list/supportskilluppackages/${this.$route.params.packageId}/users/`
                : this.$route.params.packageId && !this.$route.path.includes('faculty')
                ? `/list/skilluppackages/${this.$route.params.packageId}/users/`
                : this.$route.path.includes('facultyskilluppackages')
                ? `/list/facultyskilluppackages/users/`
                : this.$route.path.includes('supportskilluppackages')
                ? `/list/supportskilluppackages/users/`
                : `/list/skilluppackages/users/`,
          },
          {
            title: 'دانش پذیران',
            link:
              this.$route.params.packageId && this.$route.path.includes('faculty')
                ? `/list/facultyskilluppackages/${this.$route.params.packageId}/packageadminstudents/`
                : this.$route.params.packageId && this.$route.path.includes('support')
                ? `/list/supportskilluppackages/${this.$route.params.packageId}/packageadminstudents/`
                : this.$route.params.packageId && !this.$route.path.includes('faculty')
                ? `/list/skilluppackages/${this.$route.params.packageId}/packageadminstudents/`
                : this.$route.path.includes('facultyskilluppackages')
                ? `/list/facultyskilluppackages/packageadminstudents/`
                : this.$route.path.includes('supportskilluppackages')
                ? `/list/supportskilluppackages/packageadminstudents/`
                : `/list/skilluppackages/packageadminstudents/`,
          },
        ]
      }
      return [
        {
          title: 'ثبت بسته',
          link:
            this.$route.params.packageId && this.$route.path.includes('faculty')
              ? `/list/facultyskilluppackages/detail/${this.$route.params.packageId}`
              : this.$route.params.packageId && this.$route.path.includes('support')
              ? `/list/supportskilluppackages/detail/${this.$route.params.packageId}`
              : this.$route.params.packageId && !this.$route.path.includes('faculty')
              ? `/list/skilluppackages/detail/${this.$route.params.packageId}`
              : this.$route.path.includes('faculty')
              ? '/list/facultyskilluppackages/add'
              : this.$route.path.includes('support')
              ? '/list/supportskilluppackages/add'
              : '/list/skilluppackages/add',
          disable: this.isFaculty,
        },
        { title: 'سوالات متداول', link: '#' },
        { title: 'پیش نیاز', link: '#' },
        { title: 'نظرات', link: '#' },
        { title: 'محتوا دوره', link: '#' },
        { title: 'اعضا', link: '#' },
      ]
    },
  },
  methods: {
    async sendRequest() {
      await this.checkAddContent()
      if (!['facultyshortuniversitypackages', 'facultylonguniversitypackages'].includes(this.$route.fullPath) && this.addedContent) {
        await this.checkAddedQuestion()
        if (this.addedQuestions) {
          this.model.licenseStatus = 1
          this.changeStaus()
        }
      } else {
        this.error = true
        this.message = 'برای ارسال درخواست ابتدا باید محتوای دوره را اضافه نمایید'
        setTimeout(() => {
          this.error = false
          this.message = ''
        }, 5000)
      }
    },
    async fetchAvailableStatus() {
      if (this.$route.params.packageId) {
        const req = await skillUpCourseProvider.getAvailableStatus({
          productId: +this.$route.params.packageId,
          productType: 1,
        })
        if (req.status === 200) {
          this.model = req.data.data.output
          localStorage.setItem('productStatus', this.model.status)
          delete this.model.availableStatus
        }
      }
    },

    async checkAddedQuestion() {
      const req = await skillUpFrequentlyAskedQuestionsProvider.getPackageQuestions(+this.$route.params.packageId)
      if (req.data && req.data.data.output.length) {
        this.addedQuestions = true
      } else {
        this.error = true
        this.message = 'برای ارسال درخواست باید حداقل یک سوال متداول اضافه نمایید'
        setTimeout(() => {
          this.error = false
          this.message = ''
        }, 5000)
      }
    },
    async fetchPackageUsers() {
      const req = await listDataProvider.getListData({
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            text: this.$route.params.packageId,
          },
        ],
        key: 'skilluppackagepeople',
      })
      if (req.data && req.data.data.rows.length) {
        this.addedUsers = true
      }
    },
    async checkAddContent() {
      const req = await listDataProvider.getListData({
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            text: this.$route.params.packageId,
          },
        ],
        key: 'skilluppackagecourses',
      })
      if (req.data && req.data.data.rows.length) {
        this.addedContent = true
      }
    },
    async changeStaus() {
      this.submit = true
      if ((this.model.licenseStatus == 2 || this.model.licenseStatus == 3) && !this.model.description) {
        return false
      }
      const req = await skillUpCourseProvider.updateAvailableStatus({
        productId: +this.$route.params.packageId,
        productType: 1,
        licenseStatus: +this.model.licenseStatus,
        description: this.model.description,
      })
      if (req?.data?.data?.isSuccessful) {
        this.message = 'وضعیت با موفقیت تغییر یافت.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        this.fetchAvailableStatus()
        this.fetchPackageUsers()
      } else {
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        setTimeout(() => {
          this.error = false
        }, 5000)
      }
    },
  },
  watch: {
    '$route.path'() {
      this.fetchAvailableStatus()
      this.fetchPackageUsers()
    },
  },
  mounted() {
    this.fetchAvailableStatus()
    this.fetchPackageUsers()
    setTimeout(() => {
      this.pageTitle = localStorage.getItem('entityTitle')
    }, 2000)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .modal.show .modal-dialog {
  min-width: 611px !important;
  width: 611px !important;
}

// ::v-deep .modal-body {
//   min-height: 400px !important;
// }

.disable {
  background: #ced4da;
  pointer-events: none;
  border-color: #ced4da;
}

::v-deep .labelStyle {
  align-self: baseline;
}
</style>
